import { create } from 'zustand';

interface UiState {
  sidebarOpen: boolean;
  selectedAdAccountId: string | null;
  toggleSidebar: () => void;
  setSidebarOpen: (open: boolean) => void;
  setSelectedAdAccountId: (id: string | null) => void;
}

export const useUiStore = create<UiState>((set) => ({
  sidebarOpen: window.innerWidth >= 900, // closed by default on mobile
  selectedAdAccountId: null,
  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  setSelectedAdAccountId: (id) => set({ selectedAdAccountId: id }),
}));
